import React from 'react';
import loginBgi from '../assets/loginBgi.webp';
import loginClose from '@/assets/icons/login-close.webp';
import styles from '../LoginModal.module.scss';

const ModalShell = ({ showModal, onClose, children }) => {
  return (
    <div
      className={`${styles.loginModalOverlay} ${showModal ? styles.show : ''}`}
    >
      <div className={styles.loginModal}>
        <div className={styles.loginModalHeader}>
          <div className={styles.loginModalClose} onClick={onClose}>
            <img src={loginClose} alt="关闭" />
          </div>
        </div>

        <div className={styles.loginModalContent}>
          <div className={styles.loginModalLogo}>
            <img src={loginBgi} alt="登录背景" />
          </div>

          {children}
        </div>
      </div>
    </div>
  );
};

export default ModalShell;
